// Sections and components
import Crawler from './sections/Crawler';
import About from './sections/About';
import Home from './sections/Home';
import Theater from './sections/Theater';
import Loader from './sections/Loader';
import Header from './sections/Header';
import Code from './components/Code';
import Utility from './sections/Utility';

// Data and Framer Motion variants
import data from './data/data.js';
import framer from './data/framer.js';
import { useEffect, useState } from 'react';
import { Routes, Route, Link, useLocation} from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion"


function App() {
  const [isLoaded, setIsLoaded] = useState(false);
  const location = useLocation();
  const imageLoad = (src) => {
    return new Promise((resolve) => {
      let img = new Image()
      img.onload = () => resolve(true)
      img.src = src
    })
  }
  const imageLoader = () => {
    let loaded = 0;
    const imagesToPreload = [
      ...data.crawler.map(e=>"thumb_"+(e)+".jpg"),
      "iterations_new.gif",
      "screenshots_new.gif",
      "logo_black.svg",
      "logo_white.svg",
      "hal9000_1.gif",
      "hal9000_2.gif"
    ];
    imagesToPreload.forEach(async e=>{
      await imageLoad("img/"+e);
      loaded++;  
      if (loaded===imagesToPreload.length) {
        setTimeout(()=>setIsLoaded(true), 1000)
      }
    });
  }
  useEffect(()=>{
    dataLoader();
    imageLoader();
  },[]);

    const [isMobile, setIsMobile] = useState(window.innerWidth<=768);
    useEffect(() => {
        let timeout;
        const handleResize = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => { 
              setIsMobile(window.innerWidth<=1023);
            }, 200);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const dataLoader = async () => {
      //   const result = await fetch(`https://api.thegraph.com/subgraphs/name/artblocks/art-blocks`, {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({
      //     query: `
      //     {
      //       project(id:"0xa7d8d9ef8d8ce8992df33d8b8cf4aebabd5bd270-286") {
      //         id
      //         invocations
      //         artistName
      //         name
      //       }
      //     }
      //   `
      //   }),
      // });
      // const resultData = await result.json();
      //data.stats.minted = resultData.data.project.invocations;
    
      // Doesn't work for some reason
      // const result = await fetch(`https://api.opensea.io/collection/drifting-by-simon-de-mai?format=json`, {method: 'GET', headers: {
      //   'Content-Type': 'application/json',
      //   'Accept':'application/json'
      // }});
      // const resultData = await result.json();
      // data.stats.totalsales = resultData.collection.stats.total_sales;
    }

    const baseProps = {
      framer: framer,
      data: data,
      mobile: isMobile
    }
  

  /* Modal for launching teather mode */
  const [theaterModal, setTheaterModal] = useState(false);
  const [codeSection, setCodeSection] = useState({"/drifting/about":"about", "/":"home", "/drifting":"home", "/drifting/":"home", "/drifting/crawler":"crawler"}[location.pathname]);
  /* Clicks on header navigation */
  const handleCrawlerClick = () => {
    setCodeSection("crawler")
  }
  const handleProjectClick = () => {
    setCodeSection("about")
  }
  const handleTheaterClick = () => {
    setTheaterModal(true);
  }
  const handleHomeClick = () => {
    setCodeSection("home");
  }

  return (
    isLoaded ? (
      <div>
        <Code section={codeSection} {...baseProps} />
        <Theater isVisible={theaterModal} hide={() => { setTheaterModal(false) }} {...baseProps} />
        <div className="columns is-paddingless is-gapless is-desktop">
          <div className="column is-left-column">
            <Header onClick={{ project: handleProjectClick, home: handleHomeClick, crawler: handleCrawlerClick, theater: handleTheaterClick }} {...baseProps} />
          </div>
          <motion.div className="column is-right-column" {...framer.fade}>
            <AnimatePresence exitBeforeEnter>
              <Routes location={location} key={location.pathname}>
                <Route
                  path={`${process.env.PUBLIC_URL}/`}
                  element={<Home {...baseProps} />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/about`}
                  element={<About {...baseProps} />}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/crawler`}
                  element={<Crawler {...baseProps} />}
                />
                 <Route
                  path={`${process.env.PUBLIC_URL}/utility`}
                  element={<Utility {...baseProps} />}
                />
              </Routes>
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    ) : (
      <Loader key="loader" {...baseProps} />
    )
  )
}

export default App;

// <Home previews={data.previews}  />
// <Crawler images={data.crawler} player={iframeplayer} />
// <About />
















    
    
// <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>